module.exports = __webpack_public_path__ + "img/ShurenYu.86ce5e86.jpg";